import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback } from 'preact/hooks';
import FormField from './FormField';
const UserNameKanaField = ({ errors, value, onInput }) => {
    const handleFirstNameInput = useCallback((_, value) => {
        onInput("firstNameKana", value);
    }, []);
    const handleLastNameInput = useCallback((_, value) => {
        onInput("lastNameKana", value);
    }, []);
    return (_jsxs("div", Object.assign({ className: "field" }, { children: [_jsx("label", Object.assign({ className: "label" }, { children: "\u304A\u540D\u524D(\u30AB\u30CA)" }), void 0),
            _jsxs("div", Object.assign({ className: "field-body" }, { children: [_jsx(FormField, { value: value, fieldName: "firstNameKana", label: "", onInput: handleFirstNameInput, placeHolder: "\u30E4\u30DE\u30C0", inputType: "text", errors: errors }, void 0),
                    _jsx(FormField, { value: value, fieldName: "lastNameKana", label: "", onInput: handleLastNameInput, placeHolder: "\u30BF\u30ED\u30A6", inputType: "text", errors: errors }, void 0)] }), void 0)] }), void 0));
};
export default UserNameKanaField;
